import {
  DhlRadioButton as NewRadioField,
  DhlCheckbox as NewCheckboxField,
  DhlInputField as NewInputField,
} from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";

/**
 * Migration wrapper for RadioField component
 */

export const RadioField = (props) => {
  const { name, value, isChecked, onChange, children, disabled, ...rest } =
    props;

  return (
    <NewRadioField
      {...rest}
      name={name}
      value={value}
      checked={isChecked}
      onDhlChange={onChange}
      isDisabled={disabled}
    >
      {children}
    </NewRadioField>
  );
};

RadioField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

/**
 * Migration wrapper for CheckboxField component
 */
export const CheckboxField = (props) => {
  const { name, children, isChecked, onChange, disabled, ...rest } = props;

  return (
    <NewCheckboxField
      {...rest}
      name={name}
      checked={isChecked}
      isDisabled={disabled}
      onDhlChange={onChange}
    >
      {children}
    </NewCheckboxField>
  );
};

CheckboxField.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

/**
 * Migration wrapper for InputField component
 */
export const InputField = (props) => {
  const {
    name,
    value,
    onChange,
    onBlur,
    onFocus,
    onKeyDown,
    label,
    labelType,
    variant,
    disabled,
    ...rest
  } = props;

  return (
    <NewInputField
      {...rest}
      name={name}
      value={value}
      onDhlBlur={onBlur}
      onDhlFocus={onFocus}
      onDhlInput={onChange}
      onDhlKeyDown={onKeyDown}
      isDisabled={disabled}
      variant={
        variant || {
          label,
          type: labelType,
          placeholder: rest?.placeholder,
        }
      }
    />
  );
};

InputField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  label: PropTypes.string,
  labelType: PropTypes.string,
  variant: PropTypes.object,
  disabled: PropTypes.bool,
};

export default {
  RadioField,
  CheckboxField,
  InputField,
};
